module.exports = __webpack_public_path__ + "img/3.6ab2a626.jpg";